module.exports = __webpack_public_path__ + "static/media/logomax3dpro.cd149541.png";